import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

function SectionHeading({ eyebrow, title, subtitle }) {
  return (
    <div className="landing-section-heading text-center">
      {eyebrow ? <span className="landing-section-heading__eyebrow">{eyebrow}</span> : null}
      {title ? <h2 className="landing-section-heading__title">{title}</h2> : null}
      {subtitle ? <p className="landing-section-heading__subtitle">{subtitle}</p> : null}
    </div>
  );
}

export default function LandingComparison({ content }) {
  const comparison = Array.isArray(content?.comparison) ? content.comparison : [];

  if (!comparison.length) return null;

  return (
    <section className="landing-section comparison-section">
      <Container>
        <SectionHeading
          eyebrow={content?.comparison_eyebrow || 'Product Comparison'}
          title={content?.comparison_title || 'A smarter alternative to the usual setup'}
          subtitle={
            content?.comparison_subtitle ||
            'See how the platform stands out where it matters most for growth, support, and operational simplicity.'
          }
        />

        <Row className="g-4">
          {comparison.map((item, index) => (
            <Col xl={4} md={6} className="d-flex" key={`${item?.label || 'comparison'}-${index}`}>
              <Card className="comparison-card w-100 border-0">
                <Card.Body className="comparison-card__body">
                  {item?.label ? <div className="comparison-card__label">{item.label}</div> : null}

                  <div className="comparison-card__grid">
                    <div className="comparison-card__box comparison-card__box--ours">
                      {content?.comparison_ours_label ? (
                        <span className="comparison-card__tag">
                          {content.comparison_ours_label}
                        </span>
                      ) : null}
                      <strong>{item?.ours || ''}</strong>
                    </div>

                    <div className="comparison-card__box comparison-card__box--others">
                      {content?.comparison_others_label ? (
                        <span className="comparison-card__tag">
                          {content.comparison_others_label}
                        </span>
                      ) : null}
                      <strong>{item?.others || ''}</strong>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}